import Button from '../Button/Button';
import React from 'react';
import { BasicModalBelowWrapper } from './BasicModalBelowWrapper';
import { H3, ParagraphMRegular } from '../../config/designSystem/typography';
import { NEUTRAL_TEXT400 } from '../../config/designSystem/Colors';
import {  View } from 'react-native';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';





interface ModalBelowProps {
    isVisible: boolean;
    onDismiss: () => void;
    labelMain: string;
    labelTitle?: string;
    labelButton: string;
  }


export const BasicModalBelow = ({ isVisible, onDismiss, labelMain, labelTitle, labelButton}: ModalBelowProps) => {
  const {width } = useAvailableDimensions();
  const MARGIN_HORIZONTAL=20;
  const WIDTH = Math.min(600, width-2*MARGIN_HORIZONTAL);





  return (
    <BasicModalBelowWrapper isVisible={isVisible} onDismiss={onDismiss}>
      <View style={{justifyContent:'space-around', rowGap:30}}>
        <View>
          <H3 align={true}>
            {labelTitle}
          </H3>
        </View>
        <View>
          <ParagraphMRegular color={NEUTRAL_TEXT400} align={true}>
            {labelMain}
          </ParagraphMRegular>
        </View>
        <Button color='white' onPress={onDismiss} label={labelButton} width={WIDTH} marginHorizontal={0}/>
      </View>
    </BasicModalBelowWrapper>);
};


